import { render, staticRenderFns } from "./SortBigClass.vue?vue&type=template&id=7e3966ae&scoped=true"
import script from "./SortBigClass.vue?vue&type=script&lang=js"
export * from "./SortBigClass.vue?vue&type=script&lang=js"
import style0 from "./SortBigClass.vue?vue&type=style&index=0&id=7e3966ae&prod&scoped=true&lang=stylus"
import style1 from "./SortBigClass.vue?vue&type=style&index=1&id=7e3966ae&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3966ae",
  null
  
)

export default component.exports